import React from 'react';
import moment from 'moment';
import { IMPORT, EXPORT, DOMESTIC } from 'config/order-types';
import { PICKUP, DELIVERY } from 'config/movement-types';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import DescriptionListItem from '../../v2/DescriptionListItem';

const renderVessel = (shipment) => {
  const { t } = useTranslation();
  return (
    shipment?.order?.vessel_or_rail && (
      <DescriptionListItem
        label={t('VESSEL', { count: 1 })}
        className="mt-4 px-4"
      >
        {shipment.order.vessel_or_rail}
      </DescriptionListItem>
    )
  );
};

const renderLFD = (shipment) => {
  const { t } = useTranslation();
  return (
    shipment.last_free_date && (
      <DescriptionListItem label={t('TERMINAL_LFD')} className="mt-4 px-4">
        {moment(shipment.last_free_date).format('L')}
      </DescriptionListItem>
    )
  );
};

const renderLastCutDate = (shipment) => {
  const { t } = useTranslation();
  return (
    shipment.last_cut_date && (
      <DescriptionListItem
        label={titleize(t('LAST_CUT_DATE'))}
        className="mt-4 px-4"
      >
        {moment(shipment.last_cut_date).format('L')}
      </DescriptionListItem>
    )
  );
};

const renderDates = (shipment) => {
  const { t } = useTranslation();
  return (
    <>
      {renderLFD(shipment)}
      {shipment.yard_available_date && (
        <DescriptionListItem label={t('YARD_AVAILABLE')} className="mt-4 px-4">
          {moment(shipment.yard_available_date).format('L')}
        </DescriptionListItem>
      )}
      {shipment.yard_last_free_date && (
        <DescriptionListItem label={t('YARD_LFD')} className="mt-4 px-4">
          {moment(shipment.yard_last_free_date).format('L')}
        </DescriptionListItem>
      )}
    </>
  );
};

const getBody = (shipment) => {
  const { order } = shipment;
  if (
    order?.order_type === EXPORT ||
    (order?.order_type === DOMESTIC && order?.movement_type === PICKUP)
  ) {
    return (
      <>
        {renderVessel(shipment)}
        {renderLastCutDate(shipment)}
      </>
    );
  }
  if (
    order?.order_type === IMPORT ||
    (order?.order_type === DOMESTIC && order?.movement_type === DELIVERY)
  ) {
    return (
      <>
        {renderVessel(shipment)}
        {renderDates(shipment)}
      </>
    );
  }

  return renderVessel(shipment);
};

export default function ({ shipment }) {
  return (
    <div className="flex overflow-x-auto sm:-mx-4">{getBody(shipment)}</div>
  );
}
